export const environment = {
  production: true,
  apiUrl: '//apigenro.portalbd.kz/constructorapi2/',
  apiUrlMio: '//apigenro.portalbd.kz/mioapi/',
  apiUrlHgf: 'https://hgf.portalbd.kz/api/'
  // apiUrl: 'https://devbd.genro.kz/constructorapi/',
  // apiUrlMio: 'https://devmio.genro.kz/api/'
};
